import { Card, Link, Text, Title } from 'components/common'
import { BaseCardProps } from './types'
import clsx from 'clsx'

export interface MemoCardProps extends BaseCardProps {
  memo?: string
}

export const MemoCard = ({ memo, ...rest }: MemoCardProps): JSX.Element => (
  <>
    <Card shadow {...rest}>
      <div className={clsx('flex', 'justify-between', 'items-center', 'mb-3')}>
        <Title level={5} className={clsx('mb-0')}>
          メモ
        </Title>
        <Link>編集</Link>
      </div>
      <div>
        {memo ? (
          <Text>{memo}</Text>
        ) : (
          <Text mute>お客様からのメモはありません</Text>
        )}
      </div>
    </Card>
  </>
)
